<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Preface</div><v-divider class="div-after"/>
    <div class="body-1">
      This is a quick update that covers some changes to the framework's design. 
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Updated Package Structure</div><v-divider class="div-after"/>
    <div class="body-1">
      I adjusted how my packages are structured to keep the framework a little neater. I'm also
      starting to think about how to hook up the framework with a fully fleshed out UI, as well 
      as how the framework can be used in both real-time and non-real-time contexts. 
    </div>
    <v-img class="u-image-large" :src="require(`../assets/updates/4/packages.png`)"/>
      <div class="font-weight-medium">Breakdown of current packages</div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Updated Framework</div><v-divider class="div-after"/>
    <div class="body-1">
      This is a little messy at the moment, but it's got just about everything I need for my next steps (K-D trees, 
      Phong illumination, dynamic scenes). The bits in orange are missing, while the bits in red are possibly 
      going to be removed or refactored. Everything else is captured in implementation! I've also captured some rough
      notes/thoughts on the design with little annotations. 
    </div>
    <v-img class="u-image-large" :src="require(`../assets/updates/4/expanded_framework.png`)"/>
      <div class="font-weight-medium">Current framework</div>
    
  </div>
</template>

<script>
import CardList from '../components/CardList';

export default {
  name: 'U_4',
  components: { CardList, },
  data() {
    return {
      
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[4];
    },
  },
}
</script>

<style>

</style>
